import { Link } from "react-router-dom";
import { Card } from "antd";
import Meta from "antd/es/card/Meta";
import { ArrowRightOutlined } from "@ant-design/icons";
import imagePlaceholder from "../../assets/images/imagePlaceholder.jpg";
import styles from "./ProjectCard.module.scss";
import { useTranslation } from "react-i18next";

interface ProjectCardProps {
  project: Project;
}

export function ProjectCard(props: ProjectCardProps) {
  const { t } = useTranslation();
  return (
    <Link to={`/portfolio/${props.project.url}`}>
      <Card
        hoverable
        className={styles.card}
        cover={
          <div className={styles.coverBackground}>
            {props.project.images?.[0] ? (
              <img
                alt={props.project.title}
                src={props.project.images[0]}
                className={styles.coverImage}
              />
            ) : (
              <img
                alt={props.project.title}
                src={imagePlaceholder}
                className={styles.coverImage}
              />
            )}
          </div>
        }
      >
        <Meta
          title={
            <span className={styles.cardTitle}>{props.project.title}</span>
          }
          description={
            <span className={styles.projectLink}>
              {t("buttons.project")} <ArrowRightOutlined />
            </span>
          }
        />
      </Card>
    </Link>
  );
}
